import { render } from "./LogoFooter.vue?vue&type=template&id=ec0650f8"
const script = {}
script.render = render

export default script